export function timeSample() {
  const endDate = new Date();
  endDate.setUTCHours(0, 0, 0, 0);

  const NINETY_DAYS_IN_MS = 90 * 24 * 60 * 60 * 1000;
  const startDate = new Date(endDate.getTime() - NINETY_DAYS_IN_MS);

  const dates: number[] = [];
  while (startDate < endDate) {
    dates.push(startDate.getTime());
    startDate.setUTCDate(startDate.getUTCDate() + 1);
  }

  return dates;
}
